import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Share, PlusSquare, CheckCircle } from "lucide-react";

interface IOSInstallGuideProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onDismiss: () => void;
}

const IOSInstallGuide = ({ open, onOpenChange, onDismiss }: IOSInstallGuideProps) => {
  const handleGotIt = () => {
    onDismiss();
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-xs rounded-2xl p-6">
        <DialogHeader className="text-center">
          <DialogTitle className="font-serif text-xl font-bold text-foreground">
            Add Circle to your Home Screen
          </DialogTitle>
          <DialogDescription className="text-sm text-muted-foreground">
            Follow these 3 simple steps in Safari:
          </DialogDescription>
        </DialogHeader>

        <div className="mt-2 space-y-5">
          {/* Step 1 */}
          <div className="flex items-start gap-3">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-accent/10">
              <Share className="h-5 w-5 text-accent" />
            </div>
            <div>
              <p className="text-sm font-medium text-foreground">Step 1</p>
              <p className="text-sm text-muted-foreground">
                Tap the <strong>Share</strong> button at the bottom of Safari
              </p>
            </div>
          </div>

          {/* Step 2 */}
          <div className="flex items-start gap-3">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-accent/10">
              <PlusSquare className="h-5 w-5 text-accent" />
            </div>
            <div>
              <p className="text-sm font-medium text-foreground">Step 2</p>
              <p className="text-sm text-muted-foreground">
                Scroll down and tap <strong>"Add to Home Screen"</strong>
              </p>
            </div>
          </div>

          {/* Step 3 */}
          <div className="flex items-start gap-3">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-accent/10">
              <CheckCircle className="h-5 w-5 text-accent" />
            </div>
            <div>
              <p className="text-sm font-medium text-foreground">Step 3</p>
              <p className="text-sm text-muted-foreground">
                Tap <strong>"Add"</strong> in the top right corner. Done!
              </p>
            </div>
          </div>
        </div>

        <p className="mt-3 text-center text-xs text-muted-foreground/70">
          Make sure you're using Safari — it won't work in Chrome or other browsers on iPhone.
        </p>

        <Button
          className="mt-2 w-full rounded-full"
          onClick={handleGotIt}
        >
          Got it
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default IOSInstallGuide;
